export default __webpack_public_path__ + "static/media/Optometry.a9f00c4f.svg";